import { Record } from 'immutable'


const Supplier = Record({
  id:null,
  name:null,
  mail: null,
});
export default Supplier;
